export default function initHero() {
    // ==========================================================
    // HERO
    // ==========================================================

    const hero = document.querySelector(".home-hero");

    if (hero) {
        const words = hero.querySelectorAll(".home-hero__word");

        if (words.length >= 2) {
            let currentIndex = 0;

            const changeWord = () => {
                const currentWord = words[currentIndex];

                const nextIndex = (currentIndex + 1) % words.length;

                const nextWord = words[nextIndex];

                currentWord.classList.remove("is-active");

                currentWord.classList.add("is-leaving");

                nextWord.classList.remove("is-leaving");

                nextWord.classList.add("is-active");

                window.setTimeout(() => {
                    currentWord.classList.remove("is-leaving");
                }, 700);

                currentIndex = nextIndex;
            };

            window.setInterval(changeWord, 2500);
        }
    }
}
